// This data is loaded from the backend in production
// For now, provide a default set
export const DEFAULT_LANGUAGES = [
  { code: 'en', language: 'English' },
  { code: 'es', language: 'Spanish' },
  { code: 'fr', language: 'French' },
  { code: 'de', language: 'German' },
  { code: 'it', language: 'Italian' },
  { code: 'pt', language: 'Portuguese' },
  { code: 'ru', language: 'Russian' },
  { code: 'zh', language: 'Chinese' },
  { code: 'ja', language: 'Japanese' },
  { code: 'ko', language: 'Korean' },
];

export const DEFAULT_SUPPORTED_FORMATS = ['epub', 'mobi', 'azw3', 'fb2', 'djvu', 'cbz', 'cbr'];
